import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";

import DataGrid, {
  Column,
  Editing,
  Pager,
  Paging,
  RemoteOperations,
} from "devextreme-react/ui/data-grid";

import getForm from "./form";
import { doCreatePerfil, doDeletePerfil, doUpdatePerfil } from "./actions";
import ModalDelete from "../modalDelete";
import TableFilter from "../../../../Shared/tableFilter.jsx";
import { Button } from "devextreme-react";

class TablePerfil extends React.PureComponent {
  constructor(props) {
    super(props);
    this.contador = 0;
    this.state = {
      modalDelete: false,
      eventDelete: null,
    };

    this.tableRef = React.createRef();
  }

  handleAdd = () => {
    this.tableRef.addRow();
  }
  handleOpenModalEdit = (r) => {
    this.tableRef.editRow(r.row.rowIndex);
  }

  handleOpenModalDelete = (r) => {
    this.tableRef.deleteRow(r.row.rowIndex);
  }

  handleSave = (event) => {
    this.props.dispatch(doCreatePerfil(event.data.Name, event.data.Description));
  }

  handleDeletePerfil = () => {
    this.props.dispatch(doDeletePerfil(this.state.eventDelete.data.Id));
    this.setState({ modalDelete: false, eventDelete: null });
  }

  handleUpdate = (event) => {
    const data = { ...event.oldData, ...event.newData };
    this.props.dispatch(doUpdatePerfil(data.Id, data.Name, data.Description, data.Active));
  }

  handleRemove = (event) => {
    if (this.state.eventDelete === null) {
      this.setState({ modalDelete: true, eventDelete: event });
      event.cancel = true;
    }
  }

  handleCancelRemove = () => {
    this.setState({ modalDelete: false, eventDelete: null });
  }
  handleFilterChange = (text) => {
    this.tableRef.searchByText(text);
  }

  render() {
    const {
      eventDelete,
    } = this.state;
    const form = getForm();

    return (
      <React.Fragment>


        <TableFilter
          placeholder="Buscar"
          onChange={this.handleFilterChange}
          filters={this.props.filtrosTablaPerfiles}
          show={this.props.perfiles != null}
          buttons={
            {
              filter: { buttonName: "iconFilter", visible: false, buttonAction: null },
              document: { buttonName: "iconDocument", visible: false, buttonAction: null },
              download: { buttonName: "iconDownload", visible: false, buttonAction: null },
              newItem: {
                buttonName: "custom", visible: true, buttonAction: this.handleAdd, buttonText: "Agregar perfil",
              },

            }
          }

        />

        <DataGrid
          dataSource={this.props.perfiles}
          showBorders={false}
          noDataText="Sin Perfiles"
          className="custom-table"
          showColumnLines={false}
          ref={(ref) => { if (ref !== null) this.tableRef = ref.instance; }}
          showRowLines={false}
          rowAlternationEnabled
          onRowInserting={this.handleSave}
          onRowUpdating={this.handleUpdate}
          onRowRemoving={this.handleRemove}
        >

          <Editing
            form={form}
            mode="popup"
            popup={{
              title: "Roles",
              showTitle: true,
              width: 700,
              dragEnabled: false,
              showCloseButton: true,
              height: 345,
              position: {
                my: "center",
                at: "center",
                of: window,
              },
            }}
            texts={{
              addRow: "Agregar Perfil",
              saveRowChanges: "Guardar",
              cancelRowChanges: "Cancelar",
              confirmDeleteMessage: "",
              deleteRow: "Borrar",
            }}
          />

          <Column
            dataField="Code"
            allowEditing={false}
            allowAdding={false}
            caption="Código"
            allowSearch
          />

          <Column
            dataField="Name"
            caption="Nombre"
            allowSearch
            validationRules={[
              { type: "required", message: "Debe ingresar un nombre" },
              { type: "stringLength", max: 50 },
            ]}
          />
          <Column
            dataField="Description"
            caption="Descripción"
            alignment="left"
            allowSearch
            validationRules={[
              { type: "required", message: "Debe ingresar una descripción" },
              { type: "stringLength", max: 300 },
            ]}
            width="35%"
            headerCellComponent={(item) => <div style={{ textAlign: "left" }}>Descripción</div>}
            cellTemplate={(element, props) => {
              ReactDOM.render(<div style={{ textAlign: "left" }}>{props.value}</div>, element);
            }}
          />
          <Column
            alignment="right"
            cellTemplate={(element, props) => {
              ReactDOM.render(
                <div className="button-column">
                  <Button
                    onClick={() => this.handleOpenModalEdit(props)}
                    text="Editar"
                    type="success"
                    style={{ marginRight: 5 }}
                    className="slimButton"
                  />
                  <Button
                    onClick={() => this.handleOpenModalDelete(props)}
                    text="Eliminar"
                    type="danger"
                    className="slimButton"
                  />
                </div>
                , element
              )
            }}
          />


          <Pager
            visible
            showInfo
            infoText={(page, total, items) => `Página ${page} de ${total} (${items} resultados)`}
          />
          <Paging
            pageSize={20}
          />
          <RemoteOperations
            paging={false}
            filtering
            summary={false}
            groupPaging={false}
            grouping={false}
            sorting={false}
          />
        </DataGrid>
        <ModalDelete
          open={this.state.modalDelete}
          title="Eliminar perfil"
          step1Main={
            <React.Fragment>
              ¿Seguro quieres eliminar el perfil
              <span style={{ fontWeight: "bold", marginLeft: 3 }}>
                {eventDelete && eventDelete.data.Name}
              </span> ?
            </React.Fragment>
          }
          step1Sub="Al eliminar el perfil todos los usuarios que tengan este perfil asignado perderán sus privilegios."
          step2Main="Esta acción es irreversible"
          step2Sub="¿Seguro quieres eliminar el perfil?"
          step2ConfirmationText="Sí, quiero eliminar el perfil"
          deleteCallback={this.handleDeletePerfil}
          cancelCallback={this.handleCancelRemove}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  perfiles: state.mantenedores.perfiles,
  filtrosTablaPerfiles: state.mantenedores.filtrosTablaPerfiles,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(TablePerfil);
